{
  "app.name": "AppKernia",
  "app.short_name": "AK",
  "common.actions.back": "返回",
  "common.actions.cancel": "取消",
  "common.actions.close": "关闭",
  "common.actions.confirm": "确认",
  "common.actions.create": "新建",
  "common.actions.delete": "删除",
  "common.actions.edit": "编辑",
  "common.actions.next": "下一步",
  "common.actions.refresh": "刷新",
  "common.actions.reset": "重置",
  "common.actions.retry": "重试",
  "common.actions.save": "保存",
  "common.actions.search": "搜索",
  "common.actions.sign_out": "退出登录",
  "common.actions.submit": "提交",
  "common.actions.view": "查看",
  "common.avatar_upload.choose": "选择图片",
  "common.avatar_upload.choose_another": "重新选择",
  "common.avatar_upload.crop.area": "头像裁剪区域，可拖动图片调整位置",
  "common.avatar_upload.crop.confirm": "使用此裁剪",
  "common.avatar_upload.crop.description": "拖动图片调整位置，也可使用方向按钮；缩放或旋转后确认裁剪。",
  "common.avatar_upload.crop.error": "无法处理这张图片，请重新选择 JPEG、PNG 或 WebP 图片。",
  "common.avatar_upload.crop.move_down": "向下移动图片",
  "common.avatar_upload.crop.move_left": "向左移动图片",
  "common.avatar_upload.crop.move_right": "向右移动图片",
  "common.avatar_upload.crop.move_up": "向上移动图片",
  "common.avatar_upload.crop.rotate_left": "向左旋转 90 度",
  "common.avatar_upload.crop.rotate_right": "向右旋转 90 度",
  "common.avatar_upload.crop.title": "裁剪头像",
  "common.avatar_upload.crop.zoom": "缩放",
  "common.avatar_upload.crop_again": "重新裁剪",
  "common.avatar_upload.description": "选择 JPEG、PNG 或 WebP 图片，在浏览器中裁剪后安全上传；原图不会保存到浏览器存储。",
  "common.avatar_upload.invalid": "请选择不超过 5 MB 的 JPEG、PNG 或 WebP 图片。",
  "common.avatar_upload.progress": "头像上传进度 {percent}%",
  "common.avatar_upload.ready": "已生成 {size} × {size} 像素的头像预览，确认后可上传。",
  "common.avatar_upload.success": "头像已更新。",
  "common.avatar_upload.title": "个人头像",
  "common.avatar_upload.upload": "上传头像",
  "common.avatar_upload.upload_error": "头像上传失败，裁剪结果已保留，可直接重试。",
  "common.language.en-US": "English",
  "common.language.zh-CN": "简体中文",
  "common.localized_form.language_has_errors": "此语言包含需要修正的字段",
  "common.localized_form.languages": "多语言内容",
  "common.localized_form.load_error": "无法加载系统语言列表，请重试。",
  "common.localized_form.loading": "正在加载语言列表…",
  "common.locales.en-US": "English (US)",
  "common.locales.zh-CN": "简体中文",
  "common.not_available": "暂无",
  "common.states.disabled": "已停用",
  "common.states.empty": "暂无数据",
  "common.states.enabled": "已启用",
  "common.states.error": "加载失败",
  "common.states.forbidden": "无权访问",
  "common.states.loading": "加载中…",
  "common.states.offline": "网络不可用",
  "common.states.success": "操作成功",
  "meta.locale_name": "简体中文",
  "common.field_help": "查看「{name}」说明",
  "common.user_picker.title": "选择{label}",
  "common.user_picker.placeholder": "请选择人员",
  "common.user_picker.search": "按姓名、用户名或邮箱搜索",
  "common.user_picker.name": "姓名",
  "common.user_picker.username": "用户名",
  "common.user_picker.email": "邮箱",
  "common.user_picker.status": "状态",
  "common.user_picker.statuses.all": "全部状态",
  "common.user_picker.statuses.pending": "待激活",
  "common.user_picker.statuses.active": "正常",
  "common.user_picker.statuses.disabled": "已停用",
  "common.user_picker.statuses.locked": "已锁定",
  "common.user_picker.selected": "已选择 {count} 人，最多 {max} 人",
  "common.user_picker.empty": "没有符合条件的人员",
  "common.user_picker.load_error": "人员加载失败，请重试",
  "common.user_picker.unavailable": "人员信息不可用",
  "common.user_picker.no_permission": "需要用户查看权限才能选择人员",
  "common.user_picker.clear": "清空{label}",
  "common.user_picker.separator": "、",
  "common.record_picker.record": "记录",
  "common.record_picker.unavailable": "记录不可用",
  "common.record_picker.retained": "已保留原关联；记录已失效或无权读取，请重新选择。",
  "common.record_picker.placeholder": "请选择{label}",
  "common.record_picker.search": "搜索名称、编号或关键词",
  "common.record_picker.selected": "已选 {count} 项，最多 {max} 项",
  "common.record_picker.name": "名称",
  "common.record_picker.identifier": "编号",
  "common.record_picker.details": "详细信息",
  "common.markdown.format": "正文格式",
  "common.markdown.plain": "纯文本",
  "common.markdown.markdown": "Markdown",
  "common.markdown.copy": "复制原文",
  "common.markdown.public_image_required": "仅可插入已公开且扫描通过的图片。",
  "common.markdown.image": "从文件库插入图片",
  "common.markdown.fullscreen": "全屏编辑",
  "common.markdown.exit_fullscreen": "退出全屏",
  "common.money.yuan": "元",
  "common.money.invalid": "请输入范围内的金额，最多两位小数。",
  "common.json.format": "格式化 JSON",
  "common.json.invalid": "JSON 语法错误",
  "common.credentials.hide": "隐藏内容",
  "common.credentials.show": "显示内容",
  "common.credentials.pem_hint": "粘贴完整 PEM，保留 BEGIN / END 行及换行。留空保留已有凭据。",
  "common.credentials.pem_invalid": "PEM 格式不完整，请检查首尾标记及换行。",
  "common.markdown.command.bold": "粗体",
  "common.markdown.command.italic": "斜体",
  "common.markdown.command.strikethrough": "删除线",
  "common.markdown.command.hr": "分隔线",
  "common.markdown.command.title": "标题",
  "common.markdown.command.link": "链接",
  "common.markdown.command.quote": "引用",
  "common.markdown.command.code": "行内代码",
  "common.markdown.command.codeBlock": "代码块",
  "common.markdown.command.table": "表格",
  "common.markdown.command.unordered-list": "无序列表",
  "common.markdown.command.ordered-list": "有序列表",
  "common.markdown.command.checked-list": "任务列表",
  "common.markdown.command.preview": "预览",
  "common.markdown.command.edit": "编辑",
  "common.markdown.command.live": "编辑与预览",
  "common.markdown.command.title1": "1 级标题",
  "common.markdown.command.title2": "2 级标题",
  "common.markdown.command.title3": "3 级标题",
  "common.markdown.command.title4": "4 级标题",
  "common.markdown.command.title5": "5 级标题",
  "common.markdown.command.title6": "6 级标题"
}
